import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';
import promiseMiddleware from 'redux-promise-middleware'
import rootReducer from '../_reducers';

const loggerMiddleware = createLogger();

export const store = createStore(
    rootReducer,
    applyMiddleware(
        promiseMiddleware(),
        thunkMiddleware,
        loggerMiddleware
    )
);


// WEBPACK FOOTER //
// ./src/_helpers/store.js